import {Auth} from 'aws-amplify';
import axios, { AxiosRequestConfig } from 'axios';


const callWithAuth = async(config: AxiosRequestConfig) => {
  const currentSession = await Auth.currentSession();
  const jwt = currentSession.getIdToken().getJwtToken();
  if(config.headers){
    config.headers.Authorization = jwt;
  } else {
    config.headers = {
      Authorization: jwt
    };
  }
  return await axios(config);
};

export default callWithAuth